import { Injectable, effect } from '@angular/core';
import { Chart } from 'chart.js';
import { LanguageService } from './language.service';
import { toEasternArabic } from '../../shared/utils/locale-utils';

/**
 * Service that configures Chart.js locale defaults reactively.
 * Sets Chart.defaults.locale and patches tick/datalabel formatters
 * so ALL chart types (bar, line, doughnut, etc.) display localized numbers.
 */
@Injectable({
  providedIn: 'root'
})
export class ChartLocaleService {
  constructor(private languageService: LanguageService) {
    effect(() => {
      const lang = this.languageService.currentLanguage();
      this.applyLocale(lang);
    });
  }

  private applyLocale(lang: string): void {
    if (lang === 'ar') {
      Chart.defaults.locale = 'ar-EG';

      // Override tick callback for linear scales (Y-axis numbers)
      if (Chart.defaults.scales?.linear?.ticks) {
        Chart.defaults.scales.linear.ticks.callback = function(value) {
          return toEasternArabic(String(value));
        };
      }

      // Override datalabels formatter globally
      if (!Chart.defaults.plugins) {
        (Chart.defaults as any).plugins = {};
      }
      if (!Chart.defaults.plugins.datalabels) {
        (Chart.defaults.plugins as any).datalabels = {};
      }
      (Chart.defaults.plugins.datalabels as any).formatter = (value: any) => {
        if (value == null) return '';
        const str = typeof value === 'number'
          ? (Number.isInteger(value) ? value.toLocaleString('en-US') : value.toFixed(1))
          : String(value);
        return toEasternArabic(str);
      };
    } else {
      Chart.defaults.locale = 'en-US';

      if (Chart.defaults.scales?.linear?.ticks) {
        Chart.defaults.scales.linear.ticks.callback = undefined as any;
      }

      if (Chart.defaults.plugins?.datalabels) {
        (Chart.defaults.plugins.datalabels as any).formatter = undefined;
      }
    }
  }
}
